import InnerPop from '../../../../../component/newPopup/innerPop/InnerPop';
import * as css from './CommitteesListPop.css';
import {Formik, Form, useField} from 'formik';
import Input from '../../../../../component/input/Input';
import InputList from '../../../../../component/input/inputList/InputList';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import * as Yup from 'yup';
import {Committee, CommitteesListPopProps, FormValues} from './CommitteesListPop.types';

function CommitteesListPop({show, arrayHelpers, availableClubs = [], editingIndex}: CommitteesListPopProps) {
    const {t} = useTranslation('ticket');
    const currentTicket = useSelector((state: any) => state.tickets?.currentTicket);
    const [committeesField] = useField<Committee[]>('committees');

    const validationSchema = Yup.object({
        club: Yup.string().required(),
        ticketToken: Yup.string().required()
    });

    const editingCommittee = editingIndex !== undefined ? committeesField.value?.[editingIndex] : undefined;

    const initialValues: FormValues = {
        ticketToken: editingCommittee?.ticketToken || '',
        club: editingCommittee?.clubId ||( availableClubs.length === 1 ?availableClubs[0].clubId:''),
        cid: editingCommittee?.cid || null
    };

    const handleSubmit = (values: FormValues, {resetForm}: any) => {
        const selectedClub = availableClubs.find(club => club.clubId === values.club);
        if(selectedClub) {
            const committeeData: Committee = {
                title: selectedClub.title,
                ticketToken: values.ticketToken,
                clubId: selectedClub.clubId,
                club: selectedClub.club || selectedClub.title,
                tid: currentTicket?.tid,
                cid: values.cid
            };

            if(editingIndex !== undefined) {
                arrayHelpers.replace(editingIndex, committeeData);
            } else {
                arrayHelpers.push(committeeData);
            }
            resetForm();
            show.close();
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({submitForm}) => (
                <css.wrapPopup>
                    <InnerPop
                        dataCy='committeesList'
                        show={show}
                        title={t('addCommitteeTitle')}
                        buttons={{
                            whiteBtn: {text: t('cancel')},
                            blueBtn: {text: t('add'), onClick: submitForm}
                        }}
                    >
                        <Form placeholder="" onPointerEnterCapture={() => {}} onPointerLeaveCapture={() => {}}>
                            <css.committeesList>
                                <InputList
                                    name="club"
                                    text={t('committeeName')}
                                    list={availableClubs.map(club => ({
                                        text: club.title,
                                        key: club.clubId
                                    }))}
                                    icon={null}
                                    className=""
                                    valid={true}
                                    onFocus={() => {}}
                                > </InputList>
                                <Input
                                    name="ticketToken"
                                    text={t('ticketToken')}
                                    icon={null}
                                    events={{}}
                                    className=""
                                    forwardRef={null}
                                />
                            </css.committeesList>
                        </Form>
                    </InnerPop>
                </css.wrapPopup>
            )}
        </Formik>
    );
}

export default CommitteesListPop;
